import React from 'react';

import { FilterOperation, ProspectFilterField } from '../types';
import { operationsMappingWithLabel } from '../utils/operations-mapping-with-label';

import ProspectFiltersSelectDropdown from './prospect-filters-select-dropdown';

type IProps = {
  selectedField: ProspectFilterField;
  selectedOperation: FilterOperation;
  onSelectProspectFieldsOperation: (operation: FilterOperation) => void;
  disabled?: boolean;
};

const ProspectFiltersOperations: React.FC<IProps> = ({
  selectedField,
  selectedOperation,
  onSelectProspectFieldsOperation,
  disabled = false,
}) => {
  const options =
    selectedField?.operations?.map((key) => ({
      key,
      label: operationsMappingWithLabel[key],
    })) || [];

  return (
    <ProspectFiltersSelectDropdown
      className="filter-operation-select"
      selectClassName="filter-operation-dropdown"
      options={options}
      optionRenderer={(option) => <span>{option?.label || ''}</span>}
      selectedOptionKey={selectedOperation}
      selectedOptionRenderer={(option) => <span>{option?.label || ''}</span>}
      onChange={(option) => onSelectProspectFieldsOperation(option.key)}
      disabled={disabled}
    />
  );
};

export default ProspectFiltersOperations;
